import { render, staticRenderFns } from "./ItemCategoryTitle.vue?vue&type=template&id=3e03a3f2&scoped=true"
import script from "./ItemCategoryTitle.vue?vue&type=script&lang=js"
export * from "./ItemCategoryTitle.vue?vue&type=script&lang=js"
import style0 from "./ItemCategoryTitle.vue?vue&type=style&index=0&id=3e03a3f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e03a3f2",
  null
  
)

export default component.exports